/**
 * @generated SignedSource<<c3b231cef72722f4b43425b6c10b8c05>>
 * @relayHash 23af32b328af0d6ebbf94a14105dd3d8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dca8a8334e73b846479d2a07f4b02c9e52a56408a41bbac59c12bcac51ee2e12

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraReleasesEpicReleaseStatusFilter = "RELEASED" | "RELEASED_AND_UNRELEASED" | "%future added value";
export type JiraReleasesEpicFilter = {
  projectId: string;
  releaseStatusFilter?: JiraReleasesEpicReleaseStatusFilter | null | undefined;
  text?: string | null | undefined;
};
export type getEpicsRelayCycleTimeReportQuery$variables = {
  filter: JiraReleasesEpicFilter;
  first: number;
};
export type getEpicsRelayCycleTimeReportQuery$data = {
  readonly jiraReleases: {
    readonly epics: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly summary: string;
      } | null | undefined>;
    };
  };
};
export type getEpicsRelayCycleTimeReportQuery = {
  response: getEpicsRelayCycleTimeReportQuery$data;
  variables: getEpicsRelayCycleTimeReportQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "summary"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "getEpicsRelayCycleTimeReportQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraReleases",
          "kind": "LinkedField",
          "name": "jiraReleases",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v2/*: any*/),
                "concreteType": "JiraReleasesEpicConnection",
                "kind": "LinkedField",
                "name": "epics",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "JiraReleasesEpic",
                      "kind": "LinkedField",
                      "name": "nodes",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": (v3/*: any*/),
                          "action": "THROW",
                          "path": "jiraReleases.epics.nodes.id"
                        },
                        {
                          "kind": "RequiredField",
                          "field": (v4/*: any*/),
                          "action": "THROW",
                          "path": "jiraReleases.epics.nodes.summary"
                        }
                      ]
                    },
                    "action": "THROW",
                    "path": "jiraReleases.epics.nodes"
                  }
                ]
              },
              "action": "THROW",
              "path": "jiraReleases.epics"
            }
          ]
        },
        "action": "THROW",
        "path": "jiraReleases"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "getEpicsRelayCycleTimeReportQuery",
    "selections": [
      {
        "concreteType": "JiraReleases",
        "kind": "LinkedField",
        "name": "jiraReleases",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraReleasesEpicConnection",
            "kind": "LinkedField",
            "name": "epics",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraReleasesEpic",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "dca8a8334e73b846479d2a07f4b02c9e52a56408a41bbac59c12bcac51ee2e12",
    "metadata": {},
    "name": "getEpicsRelayCycleTimeReportQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "67cf5fa965a6b65fa321c9aa052f4493";

export default node;
